import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';

const RequestAccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    Object.keys(localStorage).forEach(function (key) {
      if (key.startsWith('curr_workspace')) {
        localStorage.removeItem(key);
      }
    });
  }, []);

  return (
    <Style d="column" a="center">
      <Space h="200px" />
      <img
        src="/assets/logo-syncly.svg"
        width={128}
        height={128}
        alt="syncly"
      />
      <Space h="62px" />
      <Heading type="h2">
        You do not have permission to access the workspace.
      </Heading>
      <Space h="16px" />
      <Heading type="h2">Please request access to the administrator.</Heading>
      <Space h="32px" />
      <Button
        onClick={() => {
          navigate('/', {
            replace: true,
          });
        }}
      >
        Confirm
      </Button>
    </Style>
  );
};

const Style = styled(Flex)`
  text-align: center;
`;

export default RequestAccessPage;
